import { FaEdit, FaCheck } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { FaEllipsisVertical } from "react-icons/fa6";
import { LiaWindowClose } from "react-icons/lia";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

const Actions = ({
  handleClick,
  handleDelete,
  handleActive,
  active,
}: {
  handleClick?: () => void;
  handleDelete: () => void;
  handleActive?: () => void;
  active?: string;
}) => {
  return (
    <div className="">
      <DropdownMenu>
        <DropdownMenuTrigger>
          <FaEllipsisVertical className="w-4 h-4" />
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem
            className="cursor-pointer flex items-center gap-1"
            onClick={handleDelete}
          >
            <MdDeleteForever className="w-4 h-4 text-red-600" /> Delete
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="cursor-pointer flex items-center gap-1"
            onClick={handleClick}
          >
            <FaEdit className="w-4 h-4 text-blue-400" /> <span>Edit</span>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="cursor-pointer flex items-center gap-1"
            onClick={handleActive}
          >
            {active === "active" ? (
              <>
                <LiaWindowClose className="w-4 h-4 text-red-600" />{" "}
                <span>Deactivate</span>
              </>
            ) : (
              <>
                <FaCheck className="w-4 h-4 text-blue-400" />{" "}
                <span>Activate</span>
              </>
            )}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* <FaEdit className="w-5 h-5 text-blue-400" onClick={handleClick} />
      <MdDeleteForever
        className="w-5 h-5 text-red-600"
        onClick={handleDelete}
      /> */}
    </div>
  );
};

export default Actions;
